import { createAction } from 'redux-actions'

export const toggleSchedulePanel = createAction('SCHEDULE_OPEN_PANEL')
